{
  "customer-selection-form": {
    "buttons": {
      "close": "Zurück",
      "create_new_customer_profile": "Neu erstellen",
      "select": "Auswählen",
      "selected": "Ausgewählt"
    },
    "text": {
      "search_field_label": "Suche nach Telefonnummer, E-Mail oder Name",
      "title": "Kundenauswahl"
    }
  }
}
